import React from 'react';
import PropTypes from 'prop-types';
import { isBetweenDates, isEqualDate, getWeekArray } from 'material-ui/DatePicker/dateUtils';
import DayButton from 'material-ui/DatePicker/DayButton';
import theme from 'theme/theme';

const styles = {
    root: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        fontWeight: 400,
        height: 228,
        lineHeight: 2,
        position: 'relative',
        textAlign: 'center',
        MozPaddingStart: 0,
    },
    week: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        height: 34,
        marginBottom: 2,
    },
};

class CalendarMonth extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.handleTouchTapDay = this.handleTouchTapDay.bind(this);
        this.shouldDisableDate = this.shouldDisableDate.bind(this);
        this.getWeekElements = this.getWeekElements.bind(this);
        this.getDayElements = this.getDayElements.bind(this);
    }

    handleTouchTapDay(event, date) {
        if (typeof this.props.onTouchTapDay === 'function') {
            this.props.onTouchTapDay(event, date);
        }
    }

    shouldDisableDate(day) {
        if (day === null) {
            return false;
        }

        let disabled = !isBetweenDates(day, this.props.minDate, this.props.maxDate);

        if (!disabled && typeof this.props.shouldDisableDate === 'function') {
            disabled = this.props.shouldDisableDate(day);
        }
        return disabled;
    }

    getWeekElements() {
        const weekArray = getWeekArray(this.props.displayDate, this.props.firstDayOfWeek);

        return weekArray.map((week, i) => {
            return (
                <div key={ `weekArray_${ week + i }` } style={ styles.week }>
                    {this.getDayElements(week, i)}
                </div>
            );
        }, this);
    }

    getDayElements(week, i) {
        return week.map((day, j) => {
            const isRangeStartDate = isEqualDate(this.props.rangeStart, day);
            const isRangeEndDate = isEqualDate(this.props.rangeEnd, day);
            const disabled = this.shouldDisableDate(day);
            const selected = !disabled && (isRangeStartDate || isRangeEndDate);

            if (day) {
                let buttonBackgroundStyle = {};

                if (this.props.rangeStart !== null &&
                    this.props.rangeEnd !== null &&
                    isBetweenDates(day, this.props.rangeStart, this.props.rangeEnd)
                ) {
                    buttonBackgroundStyle = {
                        background: theme.palette.rangeBackgroundColor || 'lightblue',
                    };
                }
                return (
                    <div key={ `dbd${ (i + j) }` } style={ buttonBackgroundStyle }>
                        <DayButton
                            DateTimeFormat={ this.props.DateTimeFormat }
                            locale={ this.props.locale }
                            date={ day }
                            disabled={ disabled }
                            key={ `db${ (i + j) }` }
                            onTouchTap={ this.handleTouchTapDay }
                            selected={ selected }
                        />
                    </div>
                );
            }
            return (
                <DayButton
                    DateTimeFormat={ this.props.DateTimeFormat }
                    locale={ this.props.locale }
                    date={ day }
                    disabled={ disabled }
                    key={ `db${ (i + j) }` }
                    onTouchTap={ this.handleTouchTapDay }
                    selected={ selected }
                />
            );

        }, this);
    }

    render() {
        return (
            <div style={ styles.root }>
                { this.getWeekElements() }
            </div>
        );
    }
}

CalendarMonth.defaultProps = {};
CalendarMonth.propTypes = {
    DateTimeFormat: PropTypes.func.isRequired,
    displayDate: PropTypes.object.isRequired,
    firstDayOfWeek: PropTypes.number,
    locale: PropTypes.string.isRequired,
    maxDate: PropTypes.object,
    minDate: PropTypes.object,
    onTouchTapDay: PropTypes.func,
    rangeStart: PropTypes.object,
    rangeEnd: PropTypes.object,
    shouldDisableDate: PropTypes.func,
};

export default CalendarMonth;



// WEBPACK FOOTER //
// ./src/components/input/DateRange/CalendarMonth.js